import { useParams } from 'react-router-dom';
import { getHabitTrackerChartData } from './data/habit-tracker-data-service';
import { showToast } from '../../common/domain/toast-provider';
import { useEffect } from 'react';
import { startOfDay, startOfYear, lastDayOfYear } from 'date-fns';
import { ChartIcon } from '../../common/ui/icons';
import HabitTrackerTitle from './ui/habit-tracker-title';
import { getTextFromMarkdown } from '../../common/markdown/markdown-provider';
import { useHabitTrackerStore } from './data/habit-tracker-store';
import YearView from './ui/year-view';
import { createHabitTrackerCalendar } from './domain/habit-tracker-calendar-provider';
import CalendarActionsBar from './ui/action-bars';

const HabitTrackerHome = () => {

    const { todo_id } = useParams();
    const _todo_id = Number(todo_id) || 0;

    const year = useHabitTrackerStore(store => store.year);
    const calendarData = useHabitTrackerStore(store => store.calendarData);
    const setCalendarData = useHabitTrackerStore(store => store.setCalendarData);

    useEffect(() => {
        (async () => {
            if(!_todo_id) return;

            const firstDay = startOfDay(startOfYear( new Date(year, 0, 1)));
            const lastDay = startOfDay(lastDayOfYear(firstDay));
            const response = await getHabitTrackerChartData(_todo_id, firstDay.getTime(), lastDay.getTime());

            if(!response?.isValid) {
                showToast('Get chart data error.');
            }

            setCalendarData(createHabitTrackerCalendar(
                year,
                response.habitLogs || [],
                response.todo?.todo_title ?? '',
            ));

        })();
    }, [_todo_id, setCalendarData, year]);

    useEffect(() => {
        document.title = getTextFromMarkdown(calendarData?.todo_title) || 'Habit Tracker | Productivity';
    }, [calendarData?.todo_title]);

    const goBack = () => {
        window.history.back();
    };

    return (
        <>
            {
                calendarData && _todo_id &&
                <div className="flex flex-col flex-1 leading-7 h-screen relative z-50 bg-white w-screen">

                    <div className="bg-slate-900 text-slate-100 px-4 py-3 flex items-center">
                        <ChartIcon
                            color={ '#fff' }
                            fill={ '#577091' }
                            classes="mr-4"
                        />

                        <span className="mr-10">Habit Tracker</span>

                        {/* <span className="hidden xl:block text-xs ml-auto text-slate-300">questioning approach for critical examination</span>*/ }
                    </div>

                    <div className="overflow-auto px-6 pt-4 pb-24 md:pt-10 bg-slate-50 min-h-screen">

                        <button
                            type="button"
                            onClick={ goBack }
                            className="mb-6 md:hidden">
                            &laquo; Back
                        </button>

                        <div className="xl:w-[1100px] max-w-full mx-auto">
                            <HabitTrackerTitle/>
                            <CalendarActionsBar/>
                            <YearView todo_id={ _todo_id }/>
                        </div>
                    </div>
                </div>
            }
        </>
    )
};

export default HabitTrackerHome;